import { IAlaCarteDB, IModularFamily } from '../../../redux/slices/ModularEnrolmentSlice/types';
import { IMappings } from '../../../utils/mapping';

export interface IFamilyToDisplay {
    selfSpouse?: IModularFamily[];
    children?: IModularFamily[];
    parents?: IModularFamily[];
    parentsInLaw?: IModularFamily[];
    siblings?: IModularFamily[];
}

export interface IAddDependents {
    title: string;
    currentMapping: null | IMappings;
    targetMapping: null | IMappings;
    membersToDisplay: [] | IModularFamily[];
    relation: string;
    onAddMemberClick(): void;
    onMemberEditClick(dep: IModularFamily): void;
    onMemberDeleteClick(id: string): void;
    setSelectedParentOption?(value: string): void;
    isUpgraded?: boolean;
}

export type IRelation = 'Self' | 'Spouse' | 'Child' | 'Parent' | 'Parent-in-law' | 'Sibling' | 'Partner' | '';

export type IParentOptions = {
    id: string;
    name: string;
    value: IRelation;
};

export type IGetDependentCountReturnType = {
    relation: string;
    number: number;
};

export type IGetRelationshipReturnType =
    | ''
    | 'Spouse'
    | 'spouse/partner'
    | 'child'
    | 'parent'
    | 'sibling'
    | 'child/sibling'
    | 'parent/parent-in-law'
    | 'parent|parent-in-law'
    | 'parent-in-law';

export interface IRadioItem {
    id: string;
    value: string;
    disabled?: boolean;
}

export const oneOfParentsOrInLawsOptions = ['Parents OR parents-in-law', 'Parents OR parent-in-laws'];
export const anyOfChildOrSiblingOptions = ['2 Kids (including siblings)'];
export const parentInLawsOptions = ['Parents-in-law', '1 Parent-in-law'];

export const parentOptions: IParentOptions[] = [
    {
        id: 'parent',
        name: 'Insure Parents',
        value: 'Parent'
    },
    {
        id: 'parent-in-law',
        name: 'Insure Parents-In-Law',
        value: 'Parent-in-law'
    }
];

export interface IModularValidationModal {
    relationship?: string;
    mode?: 'update' | 'delete';
    invalidBenefits?: IAlaCarteDB[];
    loading?: boolean;
}

export interface IModularValidationResponse {
    isValid: boolean;
    invalidBenefits: IAlaCarteDB[];
}

export interface IModularValidationDependentModal {
    isVisible: boolean;
    setIsVisible: () => void;
    validationModal?: IModularValidationModal;
    onConfirmDelete: () => void;
    onConfirmUpdate: () => void;
    isSubmitting: boolean;
}
